export default __webpack_public_path__ + "static/media/sfp-seur.87874426.svg";